module.exports = __webpack_public_path__ + "img/fran.4fcaa84.webp";